import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_oaph28jf: FaireBrandEntity = {
  token: "b_oaph28jf",
  type: "brand",
  name: "dilo",
  avatarUrl:
    "https://cdn.faire.com/fastly/26ae9d40a4dc92095717f623b8009a3ca890a246c58697a881bdc1a7920b5daf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8a0e03f9ba5b85e1d7935b7fad697dbfc5a35e0bcc6fbcb0f097b69bd535fa46.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/26ae9d40a4dc92095717f623b8009a3ca890a246c58697a881bdc1a7920b5daf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8a0e03f9ba5b85e1d7935b7fad697dbfc5a35e0bcc6fbcb0f097b69bd535fa46.jpeg",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 160,
  isInsider: true,
  description:
    "We started this company to bring something to customers that we found was really lacking in the marketplace - products that are damn good in the way they perform, as well as in the way they are made - No Compromise. We continue to work as hard as we can to make ridiculously good products while creating culture, providing jobs, and being a representative of small business based out of one of the coolest cities there are, Philly.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:24.421Z",
    importedBy: "entity-db-cli",
  },
};
